import React, { useMemo } from 'react';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../utils/types';
import useRetentionRows from './utils/useFilteredRetentionTable';
import {
  DEFAULT_ROW_HEADER_HEIGHT,
  DEFAULT_ROW_HEIGHT,
  MAX_TABLE_HEIGHT,
} from './RetentionTable/utils';
import { RetentionTableHeader } from './RetentionTable/RetentionTableHeader';
import RetentionTableContent from './RetentionTable/RetentionTableContent';
import { useChartContext } from '../ChartContext';

interface IProps {
  analysisId: string;
}

export default ({ analysisId }: IProps) => {
  const {
    chartData,
    settings: { chartSettings },
  } = useChartContext();
  assertCondition(chartData.queryType === QueryType.Retention);

  const { rows } = useRetentionRows({
    chartSettings,
    chartData,
    onlyVisibleMeasures: false,
  });

  const tableHeight = useMemo(() => {
    const numRows = rows.length + 1;

    const height = numRows * DEFAULT_ROW_HEIGHT + 10;

    if (height > MAX_TABLE_HEIGHT) {
      return MAX_TABLE_HEIGHT;
    }

    return height;
  }, [rows]);

  const handleContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  // XXX for now sticking to the server-side CSV data for retention
  // useCacheRetentionLlmRawDataEffect({
  //   analysisId,
  //   rows,
  //   chartTypeName: 'Retention',
  // });

  return (
    <div>
      {/* first table represents the sticky header */}
      <div
        onContextMenu={handleContextMenu}
        style={{ minHeight: DEFAULT_ROW_HEADER_HEIGHT }}
      >
        <RetentionTableHeader analysisId={analysisId} />
      </div>
      {/* second table represents the content */}
      <div onContextMenu={handleContextMenu} style={{ height: tableHeight }}>
        <RetentionTableContent analysisId={analysisId} />
      </div>
    </div>
  );
};
